import { stashKnowledgePrefill } from "./knowledgePrefill";
import { SAMPLE_NOTES } from "../v2/guide/sampleContent";

const ADMIN_OPEN_KEY = "dp_admin_open";
const HELP_OPEN_KEY = "dp_help_open";

export function stashAdminDeepLink(toolId) {
  const id = String(toolId || "").trim();
  if (!id) return;
  try {
    sessionStorage.setItem(ADMIN_OPEN_KEY, id);
  } catch {
    /* ignore */
  }
}

export function consumeAdminDeepLink() {
  try {
    const raw = sessionStorage.getItem(ADMIN_OPEN_KEY);
    sessionStorage.removeItem(ADMIN_OPEN_KEY);
    return String(raw || "").trim() || null;
  } catch {
    return null;
  }
}

export function stashHelpArticle(articleId) {
  const id = String(articleId || "").trim();
  if (!id) return;
  try {
    sessionStorage.setItem(HELP_OPEN_KEY, id);
  } catch {
    /* ignore */
  }
}

export function consumeHelpArticle() {
  try {
    const raw = sessionStorage.getItem(HELP_OPEN_KEY);
    sessionStorage.removeItem(HELP_OPEN_KEY);
    return String(raw || "").trim() || null;
  } catch {
    return null;
  }
}

/**
 * Navigate from Help CTAs or __howto_nav__ messages.
 * Targets: inbox | home-add | assistant | home-ask | approvals |
 * architecture-gallery | your-map | reports | admin | admin:<toolId> |
 * settings | help | home | help:<articleId>
 */
export function navigateHelpLink(onNavigate, routes, target) {
  const t = String(target || "").trim();
  if (!t) return false;

  if (t.startsWith("help:")) {
    stashHelpArticle(t.slice("help:".length));
    onNavigate?.(routes?.help || "help");
    return true;
  }
  if (t === "help") {
    onNavigate?.(routes?.help || "help");
    return true;
  }
  if (t === "inbox") {
    onNavigate?.(routes?.insightsInbox || "insights-inbox");
    return true;
  }
  if (t === "home-add" || t === "add-knowledge") {
    try {
      sessionStorage.setItem("dp_open_add_panel", "1");
    } catch {
      /* ignore */
    }
    onNavigate?.(routes?.addKnowledge || "add-knowledge");
    return true;
  }
  if (t === "sample-pack") {
    // Entity-first (same as first-run guide): create CPH, then enrich.
    // Content-first extract-without-entity competed with that path.
    stashKnowledgePrefill({
      scopeType: "entity",
      intent: "create",
      suggestedName: "Customer Payments Hub",
      suggestedType: "application",
      startStep: "anchor",
      pasteText: SAMPLE_NOTES,
    });
    onNavigate?.(routes?.addKnowledge || "add-knowledge");
    return true;
  }
  if (t === "upload-doc") {
    stashKnowledgePrefill({
      scopeType: "content",
      intent: "create",
      suggestedName: "",
      pasteText: "",
      startStep: "source",
      inputTab: "file",
    });
    onNavigate?.(routes?.addKnowledge || "add-knowledge");
    return true;
  }
  if (t === "fictional") {
    stashKnowledgePrefill({
      scopeType: "content",
      intent: "create",
      suggestedName: "",
      pasteText: "",
      startStep: "source",
      nextStepHint: "example",
    });
    onNavigate?.(routes?.addKnowledge || "add-knowledge");
    return true;
  }
  if (t === "assistant" || t === "home-ask") {
    try {
      sessionStorage.setItem("dp_open_ask_panel", "1");
    } catch {
      /* ignore */
    }
    onNavigate?.(routes?.home || "home");
    return true;
  }
  if (t === "home") {
    onNavigate?.(routes?.home || "home");
    return true;
  }
  if (t === "approvals") {
    onNavigate?.(routes?.baselineApprovals || "baseline-approvals");
    return true;
  }
  if (t === "architecture-gallery" || t === "your-map") {
    onNavigate?.(routes?.architectureGallery || "architecture-gallery");
    return true;
  }
  if (t === "reports") {
    onNavigate?.(routes?.reports || "reports");
    return true;
  }
  if (t === "settings") {
    onNavigate?.(routes?.settings || "settings");
    return true;
  }
  if (t === "admin") {
    onNavigate?.(routes?.admin || "admin");
    return true;
  }
  if (t.startsWith("admin:")) {
    stashAdminDeepLink(t.slice("admin:".length));
    onNavigate?.(routes?.admin || "admin");
    return true;
  }
  return false;
}

export function navigateHowto(onNavigate, routes, message) {
  const raw = String(message || "").trim();
  if (!raw.startsWith("__howto_nav__:")) return false;
  return navigateHelpLink(onNavigate, routes, raw.slice("__howto_nav__:".length));
}
